module.exports = __webpack_public_path__ + "img/battery-groupe-no-number.c7e74415.svg";